module.exports = __webpack_public_path__ + "img/mira_330m_list.df18501f.jpg";